module.exports = __webpack_public_path__ + "open-sans-italic.1afd1d044d8ad47a0e7d.woff";


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/assets/fonts/google/open-sans-italic.woff
// module id = LLIP
// module chunks = 1